import { render, staticRenderFns } from "./content-type-5.vue?vue&type=template&id=65a49a7f&scoped=true&"
import script from "./content-type-5.vue?vue&type=script&lang=js&"
export * from "./content-type-5.vue?vue&type=script&lang=js&"
import style0 from "./content-type-5.vue?vue&type=style&index=0&id=65a49a7f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a49a7f",
  null
  
)

export default component.exports